import Vue from 'vue'
import { mapState, mapGetters } from 'vuex'
import '@/utils/validatorConfig'
import DebugLog from '@/utils/DebugLog'
import Element from 'element-ui'
import ElementLangJP from 'element-ui/lib/locale/lang/ja'
import './scripts/handoverParams'

// direcrtive
import '@/directive'

import store from '@/utvStore/store'
import * as type from '@/utvStore/store/mutation-types'

// components
import utvStoreForm from '@/utvStore/components/forms'
import utvStore from '@/utvStore/components'
import uFes from '@/uFes/components'
import fetchAccountData from '@/utils/fetchAccountData'
import lineSpecial from '@/utvStore/components/recommend/line_special/line_special'
import markLp from '@/utvStore/components/MarkLp'
import * as filters from '@/utils/filters'

import { NowTime } from '@/utils/nowTime'

window.dbg = new DebugLog(2)
window.$ = jQuery
window.jQuery = jQuery
window.axios = axios
window.moment = moment
window.Vue = Vue

if ('serviceWorker' in navigator && location.protocol.startsWith('https')) {
  if (process.env.NODE_ENV === 'production') {
    navigator.serviceWorker.register('/sw.js').then(registration => {})
  } else {
    navigator.serviceWorker.register('/sw.js').then(registration => {
      registration.unregister()
    })
  }
}

import 'plyr/dist/plyr.css'

Vue.use(utvStoreForm)
Vue.use(utvStore)
Vue.use(lineSpecial)
Vue.use(markLp)
Vue.use(uFes)
Vue.use(Element, { locale: ElementLangJP })

Vue.prototype.$nowTime = new NowTime()

window.vm = new Vue({
  el: '#app',
  store,
  computed: {
    ...mapState({
      accessToken: state => state.auth.accessToken
    }),
    ...mapGetters(['isLoggedIn'])
  },
  beforeMount() {
    /**
     * アクセストークンがstoreにある場合user/infoを叩いて
     * トークンの有効性をチェックしておく(NGならログアウト)
     **/
    if (this.isLoggedIn) {
      fetchAccountData.getProfile(this.accessToken, store).catch(error => {
        setTimeout(() => {
          fetchAccountData.getProfile(this.accessToken, store).catch(error => {
            this.$store.dispatch(type.LOGOUT)
          })
        }, 3000)
      })
    }
    Object.keys(filters).forEach(key => {
      Vue.filter(key, filters[key])
    })
  }
})



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/app.js